import { Api } from '../api';
import {
  StockProductItem,
  TripCheckInHistoryRequest,
  TripCheckInHistoryResponse,
  TripCheckinRequest,
  TripCheckoutRequest,
  TripClockInHistoryRequest,
  TripClockInHistoryResponse,
  TripClockinRequest,
  TripClockinResponse,
  TripClockoutRequest,
  TripClockoutResponse,
  TripStockCreateRequest,
  TripStockCreateResponse,
  TripStockListRequest,
  TripVisitResponse,
} from './model';

export const tripApi = Api.injectEndpoints({
  endpoints: (builder) => ({
    tripCheckin: builder.mutation<TripVisitResponse, TripCheckinRequest>({
      query(arg) {
        return {
          url: `hub/orgs/api/visit/check-in`,
          method: 'POST',
          params: arg.params,
          body: arg.body,
        };
      },
    }),
    tripCheckout: builder.mutation<TripVisitResponse, TripCheckoutRequest>({
      query(arg) {
        return {
          url: `hub/orgs/api/visit/check-out`,
          method: 'POST',
          params: arg.params,
          body: arg.body,
        };
      },
    }),
    tripClockin: builder.mutation<TripClockinResponse, TripClockinRequest>({
      query(arg) {
        return {
          url: 'hub/orgs/api/trip/clock-in',
          method: 'POST',
          params: arg.params,
          body: arg.body,
        };
      },
    }),
    tripClockout: builder.mutation<TripClockoutResponse, TripClockoutRequest>({
      query(arg) {
        return {
          url: 'hub/orgs/api/trip/clock-out',
          method: 'POST',
          params: arg.params,
          body: arg.body,
        };
      },
      invalidatesTags: ['trip-clockout'],
    }),
    tripStockList: builder.query<StockProductItem[], TripStockListRequest>({
      query(arg) {
        return {
          url: 'hub/orgs/api/trip-stock',
          method: 'GET',
          params: { ...arg, random: Math.random() },
          headers: {
            'Cache-control': 'no-cache',
          },
        };
      },
      providesTags: ['trip-stock', 'trip-clockout'],
    }),
    tripStockCreate: builder.mutation<
      TripStockCreateResponse,
      TripStockCreateRequest
    >({
      query(arg) {
        const { sellerWorkspaceId, tripId, productList } = arg;
        return {
          url: `hub/orgs/api/trip-stock/${tripId}`,
          method: 'POST',
          params: {
            sellerWorkspaceId,
          },
          body: productList,
        };
      },
      invalidatesTags: ['trip-stock'],
    }),
    tripClockInHistory: builder.query<
      TripClockInHistoryResponse,
      TripClockInHistoryRequest
    >({
      query(arg) {
        const { isToday, ...params } = arg;
        return {
          url: 'hub/orgs/api/trip',
          method: 'GET',
          params: params,
          headers: {
            'Cache-control': 'no-cache',
          },
        };
      },
    }),
    tripCheckInHistory: builder.query<
      TripCheckInHistoryResponse,
      TripCheckInHistoryRequest
    >({
      query(arg) {
        return {
          url: 'hub/orgs/api/visit/me',
          method: 'GET',
          params: arg,
          headers: {
            'Cache-control': 'no-cache',
          },
        };
      },
    }),
  }),
});

export const {
  useTripClockinMutation,
  useTripClockoutMutation,
  useTripCheckinMutation,
  useTripCheckoutMutation,
  useLazyTripStockListQuery,
  useTripStockCreateMutation,
  useLazyTripClockInHistoryQuery,
  useLazyTripCheckInHistoryQuery,
} = tripApi;
